import DealList from './DealList';
import DealShow from './DealShow';

export default {
  list: DealList,
  show: DealShow,
};
